import { useScrollReveal } from "@/hooks/useScrollReveal"

const stats = [
  { value: "+10.000", label: "alunos atendidos", color: "#0E8EA0" },
  { value: "+400h", label: "de conteúdo estruturado", color: "#B038B2" },
  { value: "24h", label: "de suporte com IA", color: "#F5C542" },
  { value: "4.8★", label: "avaliação média", color: "#6CC4C4" },
]

export default function StatsSection() {
  const { ref, isVisible } = useScrollReveal()

  return (
    <section className="py-16 md:py-20" style={{ backgroundColor: "#B038B2" }}>
      <div ref={ref} className="max-w-7xl mx-auto px-5">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, i) => (
            <div
              key={i}
              className={`text-center transition-all duration-600 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: isVisible ? `${i * 120}ms` : "0ms" }}
            >
              <div className="text-4xl md:text-5xl font-black text-white mb-2">
                {stat.value}
              </div>
              <div className="text-white/80 text-base font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
